let offlineQueue = [];

offlineQueue.push = function () {
  if (this.length >= 10) {
    this.shift();
  }

  return Array.prototype.push.apply(this, arguments);
};

export const pushToQueue = (message) => offlineQueue.push(message);

export const sendQueue = ({ wsInstance }) => {
  if (offlineQueue.length) {
    offlineQueue.forEach( (msg) => wsInstance.send(JSON.stringify(msg)));
    offlineQueue = [];
  }
};
